// src/app/reducers/customer.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  accountIsCreatedAction,
  removeRecentAccountAction
} from 'src/app/actions/account';

export interface AccountState {
  accounts: any[];
  recentAccount?: any;
}

export const initialState: AccountState = {
  accounts: [],
  recentAccount: null
};

const _accountReducer = createReducer(
  initialState,
  on(accountIsCreatedAction, (state, { newAccount }) => ({
    ...state,
    accounts: [...state.accounts, newAccount],
    recentAccount: newAccount
  })),
  on(removeRecentAccountAction, state => ({
    ...state,
    recentAccount: null
  }))
);

export function accountReducer(
  state: AccountState | undefined,
  action: Action
) {
  return _accountReducer(state, action);
}
